<div class="fixed-min-header-height pt-3 pt-md-4 pt-lg-0 grey-bg">
    <div class="container-fluid product-lisitng-wrapper cart-lisitng-wrapper">
      <div class="row">
        <div class="col-12">
          <a [routerLink]="['/mycart/']" title="back" class="back-listing-btn d-none d-lg-block back-cart" href="javascript:void(0);">
            <svg width="15px" height="16px" viewBox="0 0 15 16" version="1.1" xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink">
              <title>Combined Shape</title>
              <desc>Created with Sketch.</desc>
              <g id="SCREENS" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="210209_shopboss_cart" transform="translate(-1719.000000, -1333.000000)" fill="#D9394C"
                  fill-rule="nonzero">
                  <path
                    d="M1726.46967,1333.46967 L1727.53033,1334.53033 L1721.811,1340.24967 L1734,1340.25 L1734,1341.75 L1721.811,1341.74967 L1727.53033,1347.46967 L1726.46967,1348.53033 L1719.46967,1341.53033 C1719.2034,1341.26406 1719.1792,1340.8474 1719.39705,1340.55379 L1719.46967,1340.46967 L1726.46967,1333.46967 Z"
                    id="Combined-Shape"></path>
                </g>
              </g>
            </svg> Back </a>
        </div>
      </div>
      <div class="row">
        <div class="col-12 fixed-width-right-column">
          <form id="payment-form" method="POST" action="https://merchant.com/charge-card">
            <div class="new-card-payment second">
              <div class="payment-box">
                <p (click)="newpaymentEvent()">Pay with a new card</p>
                <div class="input-box">
                  <label>Enter Card Details</label>
                  <div class="card-frame">
                    <!-- form will be added here -->
                  </div>
                  <div class="form-group">
                      <input type="checkbox" id="save" (change)='changeSaveCard($event)'>
                      <label for="save">Save this card</label>
                  </div>
                </div>
              </div>
            </div>
            <!-- add submit button -->
            <button id="pay-button" class='newcard-payment'  disabled>
              PAY 
            </button>
          </form>
          <button id="submit-savecard" (click)="test()">
            test
          </button>
          <input id='card-token' value=''>
        </div>
        
      </div>
    </div>
  </div>
  